export const CUSTOMER_FORM_MAIN = 'CustomerFormMain';
export const CUSTOMER_EVENTS_FORM = 'CustomerEventsForm';
export const CUSTOMER_TASK_FORM = 'CustomerTaskForm';
export const CUSTOMER_FILES_FORM = 'CustomerFilesForm';
export const CUSTOMER_ORGANISATION_FORM = 'CustomerOrganisationForm';
